import React, { Component } from 'react';
import { Button, Card, CardBody, CardHeader, Col, Collapse, Row } from "reactstrap";
import LabelInput from "../../../components/Input/LabelInput/LabelInput";
import LabelDropdown from "../../../components/Dropdown/LabelDropdown/LabelDropdown";

// import wifi_icon from '../../../assets/img/recept_checkin/wifi.svg';
import building_icon from '../../../assets/img/recept_checkin/building.svg';
import floor_icon from '../../../assets/img/recept_checkin/floor.svg';
import pass_icon from '../../../assets/img/recept_checkin/pass.svg';

import * as common from '../../../const/Common/CommonFunc';
import { Button as SementicBtn, Checkbox, Dropdown, Icon, Input, Search } from "semantic-ui-react";
import * as EmailValidator from "email-validator"
import * as actionCreator from "../../../store/Action";
import {connect} from "react-redux";
// import DatePicker from 'react-datepicker'
import _ from 'lodash'
import axios from "../../../axios/axios_visitortag";
// import axiosTags from "../../../axios/axios_tag";
import Cookies from 'js-cookie'
import swal from "sweetalert";
import cry_icon from "../../../assets/img/sweet/cry.svg";
import are_you_sure_icon from "../../../assets/img/sweet/question.svg";
import { Tag, Tooltip } from "antd";
import '../../../react-datepicker.css'
import { MDBDataTable } from "mdbreact";
import ScanQR from "./ScanQR/ScanQR";
import $ from "jquery";
import uuid from 'uuid'
import Validation_MobEmail from "./Validation_MobEmail/Validation_MobEmail";
import './Dashboard.scss'
import * as util from '../../../util/Validator';
import CompareModal from "./CompareModal/CompareModal";
import IntlTelInput from 'react-intl-tel-input';
import 'react-intl-tel-input/dist/main.css';
import LabelInputDropdown from "../../../components/Input/LabelInputDropdown/LabelInputDropdown";
import * as DropDownConst from "../../../store/Reducer/DropDownConst";
import Lbl from "../../../components/Label/Lbl";
import VisitorPhotoUpload from "../../../components/VisitorPhotoUpload/VisitorPhotoUpload";
import apiConfig from "../../../axios/axios_api_services";
import RightSideDrawer from "./SideDrawer/RightSideDrawer";
import {withTranslation} from "react-i18next";
import i18n from "i18next";
import * as TableHeaders from '../../../const/table/TableHeaders';
import MobileScanQR from "./ScanQR/MobileScanQR";

class App extends Component {
  state = {
    isChangeHost: false,
    isHidden: false,

    search_host: '',
    host_1: '',
    host_2: '',
    host_1_userid: 0,
    host_2_userid: 0,

    host_mobile: '', // disable
    host_extension: '', // disable
    host_designation: '', // disable
    host_department: '', // disable

    // wifi package
    isWifi: false,
    wifi_package: 0,
    wifi_expire_date: '',
    selectedDate: new Date().setDate(new Date().getDate() + 1),

    //visitor
    isTag: false,
    tagColor: '',
    tagDescritpition: '',

    search_visitor: '',
    visitor_identify: '',
    isVisitor: true, visitor_id: 0, visitor_title: '', visitor_fname: '', visitor_lname: '', visitor_mobile_background: '', visitor_mobile: '', visitor_mobile_: '',visitor_personal_email: '', visitor_corporate_email: '', visitor_email: '', visitor_valid_email: false, visitor_valid_mobile: false, visitor_company: '', visitor_purpose: '', screenshot: '',

    reception_cards: [],

    meeting_building: '',
    meeting_building_id: 0,
    meeting_floor: '',
    meeting_pass_no: '',meeting_pass_no_text:'',

    hostList: [],
    coporate_host: [],

    selectedCards: [],
    custom_visitors_list: [],
    host_loader: false,
    loader: false,

    visitBefore: true,
    visitBefore_obj: null,
    isScanQR: false,

    companyList: [],
    companyList_: [],
    company_loader: false,
    isUseCard: false,
    isCompareModal: false,
    type: "NIC",visibleRightDrawer: false,
    search_mobile:'',
    valid_search_mobile:false,

    visitor_vehicle_no:'',
    visitor_remark:'',
    valid_vehicle_no:false,
    visitor_identify_type:'NIC',
    searchOptions: DropDownConst.IdentificationsHostWithoutVN(this.props.t),
    enable_overdue: true,

    search_mode: false,
    mobile_confirmation_condi:false,
    emailOptions: DropDownConst.emailOptions,
    visitors_columns: TableHeaders.visitorsColumns(this.props.t),
    children_list: [],
    visitor_info_type: 'ADULT',
    emailType: 'Corporate',
    emailInputDisabled : false, isMobileQR: false
  };


  screenshotHandler = (screenshot) => {
    this.setState({
      screenshot: screenshot
    });
  };


  handleChange = name => event => {
    let value = event.target.value;
    if (name === "search_visitor") {
      this.setState({
        [name]: value
      })
    } else if (name === "visitor_mobile") {
      let onlyDigit = new RegExp("^\\d+$");
      if (onlyDigit.test(value) || value.length === 0) {
        let isValidMobile = util.mobileNumValidator(value, "ALL", 1);
        if (isValidMobile) {
          this.setState({
            visitor_valid_mobile: true,
            [name]: event.target.value
          });
        } else {
          this.setState({
            visitor_valid_mobile: false,
            [name]: event.target.value
          });
        }
      }
    } else if (name === "visitor_email") {
      let validateEmail = EmailValidator.validate(value);
      if (validateEmail) {
        this.setState({
          visitor_valid_email: true,
          [name]: value
        });
      } else {
        this.setState({
          visitor_valid_email: false,
          [name]: value
        });
      }
    } else if (name === "visitor_vehicle_no") {
      let validateVehicleNo = util.vehicleNumberPlateValidation(value);
      if (validateVehicleNo) {
        this.setState({
          valid_vehicle_no: true,
          [name]: value
        });
      } else {
        this.setState({
          valid_vehicle_no: false,
          [name]: value
        });
      }
    } else {
      this.setState({
        [name]: value
      });
    }
  };

  handleOverdueStatus = () => {
    this.setState({
      enable_overdue: !this.state.enable_overdue
    })
  }

  changeHostOnChange = () => {
    if (!this.state.isChangeHost) {
      if (this.state.host_1.trim() !== '') {
        this.setState({
          search_host: '',
          host_mobile: '',
          host_extension: '',
          host_designation: '',
          host_department: '',
          isChangeHost: !this.state.isChangeHost
        })
      } else {
        common.notifyMessage("Please search Host A")
      }
    } else {
      this.setState({
        search_host: '',
        host_2_userid: 0,
        host_2: '',

        host_mobile: '',
        host_extension: '',
        host_designation: '',
        host_department: '',
        isChangeHost: !this.state.isChangeHost
      })
    }
  };

  handleSelectHost = (e, { value }) => {
    let data = this.state.coporate_host;
    let selectedHost = null;
    data.map((host, index) => {
      if (host.value === value) {
        selectedHost = host;
      }
    });

    let userId = selectedHost.userId;
    let name = selectedHost.firstName + " " + selectedHost.lastName;
    let mobile = selectedHost.mobile === null || selectedHost.mobile === undefined ? "-" : selectedHost.mobile;
    let extention = selectedHost.extention === null || selectedHost.extention === undefined ? "-" : selectedHost.extention;
    let department = selectedHost.department === null || selectedHost.department === undefined ? "-" : selectedHost.department;
    let designation = selectedHost.designation === null || selectedHost.designation === undefined ? "-" : selectedHost.designation;

    if (this.state.isChangeHost) {
      this.setState({
        host_2: name,
        host_2_userid: userId,

        search_host: value,
        host_mobile: mobile,
        host_extension: extention,
        host_designation: designation,
        host_department: department,
      })
    } else {
      this.setState({
        host_1: name,
        host_1_userid: userId,

        search_host: value,
        host_mobile: mobile,
        host_extension: extention,
        host_designation: designation,
        host_department: department,
      })
    }
  };

  handleSearchHost = (e, { searchQuery }) => {
    let length = searchQuery.trim().startsWith("07") ? 6 : searchQuery.trim().startsWith("94") ? 7 : 3;

    if (searchQuery.trim().length > 2) {
      if (searchQuery.trim().length === length) {
        this.setState({
          coporate_host: []
        });

        const headers = { "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8") };

        let coperateId = this.props.usr_obj.corporates[0].corporateId;
        let coporate_host = [];

        // Get Host Details From Name Suggestions
        axios.get(apiConfig.CORPORATE_HOST_SEARCH({corporateId:coperateId,searchValue:searchQuery.trim()}), { headers: headers })
          .then(response => {
            if (response.data.success) {
              let data = response.data.hostList;

              if (data.length !== 0) {
                data.map((host, index) => {
                  let host_mobile = searchQuery.startsWith("94") ? host.mobile.startsWith("0") ? host.mobile.split("0").join('94') : host.mobile : host.mobile;
                  let empId = host.empId !== null && host.empId !== "" ? " - " + host.empId : "";
                  let text = host_mobile + " - " + host.firstName + " " + host.lastName + empId;

                  const data = {
                    ...host,
                    key: index,
                    text: text,
                    value: uuid()
                  };
                  coporate_host.push(data)
                })
              }
            }

            this.setState({
              host_loader: false,
              coporate_host: coporate_host,
            })
          })
          .catch(async error => {
            let result = await common.checkErrorResponse(error);
            if (result === 1) {
              this.handleSearchHost(e, { searchQuery });
            }
          });
      }
    } else {
      this.setState({ coporate_host: [], host_loader: false })
    }
  };

  onPhoneNumberChange = (condition, value, object, withdialcode) => {
    value = value.startsWith("00") ? "+" + value.substr(2) : value;
    condition = util.customMobileValidation(withdialcode.substr(1).replace(/\s/g, ""),condition);

    this.setState({
      visitor_valid_mobile: condition,
      visitor_mobile: withdialcode,
      visitor_mobile_: value
    });
  };

  searchPhoneNumber = (condition, value, object, withdialcode) => {
    value = value.startsWith("00") ? "+" + value.substr(2) : value;
    condition = util.customMobileValidation(withdialcode.substr(1).replace(/\s/g, ""),condition);

    this.setState({
      search_visitor: withdialcode.substr(1).replace(/\s/g, ""),
      search_mobile:value,
      valid_search_mobile:condition
    });
  };

  selectVisitor = (selectedVisitor) => {
    let list = this.state.custom_visitors_list;
    let condition = false;

    let userId = selectedVisitor.userId;

    let identificationValue = selectedVisitor.identificationValue === null || selectedVisitor.identificationValue === undefined ? this.state.visitor_identify : selectedVisitor.identificationValue;
    let companyName = selectedVisitor.companyName === null || selectedVisitor.companyName === "" || selectedVisitor.companyName === undefined ? "-" : selectedVisitor.companyName;
    let corporateEmail = selectedVisitor.corporateEmail? selectedVisitor.corporateEmail : "";
    let email = selectedVisitor.email === null || selectedVisitor.email === "" || selectedVisitor.email === undefined ? "" : selectedVisitor.email;
    let firstName = selectedVisitor.firstName === null || selectedVisitor.firstName === "" || selectedVisitor.firstName === undefined ? "-" : selectedVisitor.firstName;
    let lastName = selectedVisitor.lastName === null || selectedVisitor.lastName === "" || selectedVisitor.lastName === undefined ? "-" : selectedVisitor.lastName;
    let title = selectedVisitor.title === null || selectedVisitor.title === undefined ? "Mr" : selectedVisitor.title;
    let mobile = selectedVisitor.mobile === null || selectedVisitor.mobile === "" || selectedVisitor.mobile === undefined ? "" : selectedVisitor.mobile;
    let screenshot = selectedVisitor.photoPath === null || selectedVisitor.photoPath === "" || selectedVisitor.photoPath === undefined ? "" : selectedVisitor.photoPath;
    let identificationType = (selectedVisitor.identificationType === null ||  selectedVisitor.identificationType === "") && (this.state.type === 'Mobile' || this.state.type === 'Email') ? 'NIC' :
      (selectedVisitor.identificationType === null ||  selectedVisitor.identificationType === "") && !(this.state.type === 'Mobile' || this.state.type === 'Email') ? this.state.type : selectedVisitor.identificationType;

    let visitor_valid_email = false;
    let visitor_valid_mobile = false;
    email !== "" || corporateEmail !== "" ? visitor_valid_email = true : visitor_valid_email = false;
    mobile !== "" ? visitor_valid_mobile = true : visitor_valid_mobile = false;

    let isTagRemark = selectedVisitor.tagRemark;
    let remarkColour = selectedVisitor.remarkColour;
    let remark = selectedVisitor.remark;

    if (list.length !== 0) {
      list.map((custom, index) => {
        if (custom.visitor_identify === identificationValue) {
          condition = true;
        }
      })
    }

    let companyList_ = [];
    const obj = {
      key: uuid(),
      text: companyName,
      value: companyName,
    };
    companyList_.push(obj);

    let emailType = 'Corporate';
    if (corporateEmail === '' && email === '') {
      emailType = 'Personal';
      this.setState({emailInputDisabled:false});
    } else if (corporateEmail !== '') {
      this.setState({emailInputDisabled:true});
    } else if (email !== '') {
      emailType = 'Personal';
      this.setState({emailInputDisabled:false});
    }

    if (!condition) {
      this.setState({
        isVisitor: true,
        tagColor: remarkColour,
        tagDescritpition: remark,
        isTag: isTagRemark,

        visitor_identify: identificationValue,
        visitor_id: userId,
        visitor_title: title,
        visitor_fname: firstName,
        visitor_lname: lastName,
        visitor_mobile_background: mobile,
        visitor_mobile: mobile,//mobile,
        visitor_mobile_: mobile,
        visitor_corporate_email: corporateEmail,
        visitor_personal_email: email,
        visitor_email: corporateEmail? corporateEmail : email? email : "",
        visitor_valid_email: visitor_valid_email,
        visitor_valid_mobile: visitor_valid_mobile,
        visitor_company: companyName,
        companyList_: companyList_,
        screenshot: screenshot,
        visitor_identify_type:identificationType,
        emailType:emailType
      });
    } else {
      common.notifyMessage("Already assign this visitor - " + identificationValue);
    }
  };

  searchVisitorUsingVisitorIdentity = () => {
    let identity = this.state.search_visitor.trim();
    let isValidIdentity = false
    if (this.state.type === "NIC" || this.state.type === "Passport" || this.state.type === "Driving Licence") {
      isValidIdentity = util.identityValueValidator(identity, this.state.type);
    } else if (this.state.type === "Mobile") {
      this.state.valid_search_mobile ? isValidIdentity = true : common.notifyMessage("Please add a valid mobile number.");
    } else if (this.state.type === "Email") {
      EmailValidator.validate(identity) ? isValidIdentity = true : common.notifyMessage("Please add a valid email.");
    } else {
      isValidIdentity = true;
    }

    let valid = this.searchDuplicatesInMeetingQueue();

    if (isValidIdentity && valid) {
      this.setState({ search_mode: true })
      this.clearVisitor();
      this.props.spinnerHandler(true);
      const headers = {
        "Authorization": "Bearer" + Cookies.get("68a6102f6ed24899420170004a0273b8")
      };

      let corporateId = this.props.usr_obj.corporates[0].corporateId;
      // Get visitor Details From Name Suggestions
      axios.get(apiConfig.CORPORATE_VISITOR_IDENTIFY_SEARCH({
        corporateId:corporateId,
        identifyValue:identity,
        searchType: this.state.type === "Mobile" ? `mobile` : this.state.type === "Email" ? 'email' : undefined
      }), { headers: headers })
        .then(response => {
          console.log(response);
          if (response.data.success) {
            if (this.state.type === "Mobile") this.setState({ mobile_confirmation_condi: true })
            this.finalizeVisitorDetails(response.data);
          } else {
            this.setState({
              isVisitor: false,
              visitor_identify: !(this.state.type === 'Mobile' || this.state.type === 'Email') ? identity : '',
              reception_cards: this.props.all_available_card,
              visitor_mobile: this.state.type === 'Mobile' ? this.state.search_mobile.trim() : "",
              visitor_mobile_: this.state.type === 'Mobile' ? this.state.search_mobile.trim() : "",
              visitor_email: this.state.type === 'Email' ? this.state.search_visitor.trim() : "",
              visitor_valid_mobile: this.state.type === 'Mobile',
              visitor_valid_email: this.state.type === 'Email',
              visitor_identify_type: this.state.type === 'Mobile' || this.state.type === 'Email' ? 'NIC' : this.state.type
            })
          }
        })
        .catch(async error => {
          let result = await common.checkErrorResponse(error);
          if (result === 1) {
            this.searchVisitorUsingVisitorIdentity()
          }
        })
        .finally(fin => {
          this.props.spinnerHandler(false);
        })
    }
  };

  searchDuplicatesInMeetingQueue = () => {
    let visitorsList = this.state.custom_visitors_list;
    let valid = true;
    for (let key in visitorsList) {
      let obj = visitorsList[key];
      if ((this.state.type === "NIC" || this.state.type === "Driving Licence" || this.state.type === "Passport") && obj.identificationValue.toLowerCase() === this.state.search_visitor.toLowerCase()) {
        common.notifyMessage("An attendee is already in attendees queue with this identification. Please try another one");
        valid = false;
        break;
      } else if (this.state.type === "Mobile" && (obj.mobile === this.state.search_mobile || obj.mobile.replace(/^0/, "") === this.state.search_mobile || obj.mobile === this.state.search_mobile.replace(/^0/, ""))) {
        common.notifyMessage("An attendee is already in attendees queue with this mobile. Please try another one");
        valid = false;
        break;
      } else if (this.state.type === "Email" && obj.email === this.state.search_visitor) {
        common.notifyMessage("An attendee is already in attendees queue with this email. Please try another one");
        valid = false;
        break;
      }
    }
    return valid;
  }

  finalizeVisitorDetails = (resp) => {
    let cards_list = [];

    if (resp.error_code === 710) {
      common.warningAlert(resp.message, 1);

      // let cards_list = this.props.all_available_card;
      cards_list.push({
        key: resp.card.cardId,
        text: resp.card.passId,
        value: resp.card.cardId,
        image: { avatar: true, src: pass_icon },
      });
      // this.props.receptionAllAvailableCardHandler(cards_list);

      this.selectVisitor(resp.visitor.visitor);
      this.setState({
        isUseCard: true,
        meeting_pass_no_text: resp.card.passId,
        meeting_pass_no: resp.card.cardId,
        reception_cards: cards_list
      })
    } else {
      let res = resp.visitorList;
      if (res.length !== 0) {
        let selected_visitor = res[0];

        if (!selected_visitor.visitBefore) {
          this.setState({
            visitBefore: false,
            visitBefore_obj: selected_visitor
          })
        } else {
          this.selectVisitor(selected_visitor.visitor);
        }

        this.setState({ reception_cards: this.props.all_available_card })
      }
    }
  };

  imagePathHandler = () => {
    var imagePath = this.state.screenshot;
     this.props.imagePathHandler(imagePath);

  }

  handleSearchCompany = (e, { searchQuery }) => {
    if (searchQuery.trim().length > 2) {
      let companyList = this.state.companyList;

      const re = new RegExp(_.escapeRegExp(searchQuery), 'i');
      const isMatch = (result) => {
        return re.test(result.value);
      };

      let filter = _.filter(companyList, isMatch);
      if (filter.length === 0) {
        const obj = {
          key: uuid(),
          text: searchQuery.trim(),
          value: searchQuery.trim(),
        };
        filter.push(obj)
      }

      this.setState({
        companyList_: filter,
      })
    }
  };
  handleExpireDate = (e) => {
    let date = this.convertDate(e);
    this.setState({
      selectedDate: new Date(e).getTime(),
      wifi_expire_date: date
    });
  };
  convertDate = (date) => {
    let d = new Date(date);
    d = d.getFullYear() + "-" + ("0" + (d.getMonth() + 1)).slice(-2) + "-" + ("0" + d.getDate()).slice(-2) + " " + ("0" + d.getHours()).slice(-2) + ":" + ("0" + d.getMinutes()).slice(-2) + ":" + ("0" + d.getSeconds()).slice(-2);
    return d;
  };
  changeWifiSelector = () => {
    if (!this.state.isWifi) {
      this.setState({
        isWifi: !this.state.isWifi
      })
    } else {
      this.setState({
        isWifi: !this.state.isWifi,
        wifi_package: 0
      })
    }
  };
  wifiOnChange = (e, { value }) => {
    this.setState({
      wifi_package: value
    });
  };
  buildingOnChange = (e, { value }) => {
    let selectedBuilding = this.props.all_building_list[value];

    const floor_options = [];
    if (selectedBuilding.floors.length !== 0) {
      selectedBuilding.floors.map((element, index) => {
        floor_options.push({
          key: element.floor_id,
          text: element.description,
          value: element.floor_id,
          image: { avatar: true, src: floor_icon },
        })
      })
    }

    this.setState({
      meeting_building: value,
      meeting_building_id: selectedBuilding.buildingId
    });
    this.props.receptionAllFloorHandler(floor_options);
  };

  floorOnChange = (e, { value }) => {
    this.setState({
      meeting_floor: value
    });
  };

  noCardsAvailable = () => {
    swal({
      title: "Hey " + this.props.usr_obj.fullName + ", No cards available for this branch",
      icon: cry_icon,
      closeOnClickOutside: false,
      buttons: {
        // cancel: 'Cancel',
        dangerMode: {
          text: "Okay",
          value: "action",
          className: "okay-btn"
        }
      },
    })
      .then((value) => {
        switch (value) {
          case "action":
            break;
          default:
        }
      });
  };

  companyOnChange = (e, { value }) => {
    this.setState({
      visitor_company: value
    });
  };

  passOnChange = (e, { value }) => {
    this.setState({
      meeting_pass_no: value
    });
  };

  removeVisitor = (index, visitor) => {
    const {t} = this.props;
    swal({
      title: "Do you want to remove " + visitor.firstName + "?",
      icon: are_you_sure_icon,
      closeOnClickOutside: false,
      buttons: {
        cancel: t('cancel'),
        dangerMode: {
          text: t('remove'),
          value: "action",
          className: "remove-btn"
        }
      }
    })
      .then((value) => {
        switch (value) {
          case "action":
            let custom_array = this.state.custom_visitors_list;

            custom_array.splice(index, 1);
            this.setState({
              custom_visitors_list: custom_array
            });
            break;
          default:
        }
      });
  };

  purposeOnChange = (e, { value }) => {
    this.setState({
      visitor_purpose: value
    });
  };

  titleOnChange = (e, { value }) => {
    this.setState({
      visitor_title: value
    });
  };

  identifyTypeOnChange = (e, { value }) => {
    this.setState({
      visitor_identify_type: value
    });
  };

  checkHostValidation = () => {
    if (!this.state.isChangeHost) {
      // check host A details
      if (this.state.host_1.trim() === '') {
        common.notifyMessage("please select host A");
        return false
      } else {
        return true
      }
    } else {
      // check host B details
      if (this.state.host_2.trim() === '') {
        common.notifyMessage("please select host B");
        return false
      } else {
        return true
      }
    }
  };

  checkVisitorValidation = () => {

    if (this.state.custom_visitors_list.length === 0 || this.state.visitor_purpose === "") {
      if (this.state.visitor_purpose === "") {
        common.notifyMessage("please select visitor purpose");
        return false
      } else {
        common.notifyMessage("please enter visitor details");
        return false
      }
    } else {
      return true;
    }
  };

  checkBuildingValidation = () => {
    if (this.state.meeting_floor === '' || this.state.meeting_building_id === "") {
      common.notifyMessage("please enter building and floor");
      return false;
    } else {
      return true;
    }
  };

  checkWifiValidation = () => {
    if (this.state.isWifi) {
      if (this.state.wifi_package === 0 || this.state.wifi_expire_date === '') {
        common.notifyMessage("please enter wifi package details");
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  };

  checkVisitorEnterVisitorDetails = () => {
    let result = false;
    if (this.state.visitor_identify.trim() === '' || this.state.visitor_title === '' || this.state.visitor_fname.trim() === '' || this.state.visitor_lname.trim() === '' || this.state.visitor_mobile.trim() === '' || this.state.meeting_pass_no === "") {
      this.state.visitor_identify.trim() === '' ? common.notifyMessage("please enter visitor identity") :
        (this.state.type === 'Email' || this.state.type === 'Mobile') && this.state.visitor_identify_type.trim() === '' ? common.notifyMessage("please enter visitor identity type") :
          this.state.visitor_title.trim() === '' ? common.notifyMessage("please enter visitor title") :
            this.state.visitor_fname.trim() === '' ? common.notifyMessage("please enter visitor first name") :
              this.state.visitor_lname.trim() === '' ? common.notifyMessage("please enter visitor last name") :
                this.state.visitor_mobile.trim() === '' ? common.notifyMessage("please enter visitor mobile") :
                  this.state.meeting_pass_no === '' ? common.notifyMessage("please choose pass number") :
                    common.notifyMessage("please enter visitor details")

    } else {
      if (this.state.visitor_mobile.trim() !== '' && this.state.visitor_valid_mobile) {
        if ((this.state.visitor_email.trim() === '' && !this.state.visitor_valid_email) || (this.state.visitor_email.trim() !== '' && this.state.visitor_valid_email)) {
          if (util.identityValueValidator(this.state.visitor_identify.trim(), this.state.visitor_identify_type)) {
            if((this.state.visitor_vehicle_no.trim() === '' && !this.state.valid_vehicle_no) || (this.state.visitor_vehicle_no.trim() !== '' && this.state.valid_vehicle_no)) {
              result = true;
            } else {
              common.notifyMessage("please enter valid vehicle no!");
            }
          }
        } else {
          common.notifyMessage("please enter valid email!");
        }
      } else {
        common.notifyMessage("please enter valid mobile no!");
      }
    }
    return result;
  };


   checkMobileNumber = () => {
    let {visitor_mobile} = this.state;
    this.props.spinnerHandler(true);
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };

    let corporateId = this.props.usr_obj.corporates[0].corporateId;
    // Get visitor Details From Name Suggestions
    axios.get(apiConfig.CORPORATE_VISITOR_MOBILE_SEARCH({corporateId:corporateId,mobile:visitor_mobile}), { headers: headers })
      .then(response => {
        if (response.data.success) {
          let selected_visitor = response.data.visitorList;
          let condition = false;

          if (this.state.visitor_id === selected_visitor.visitor.userId) {
            condition = true;
          }

          if (!condition) {
            this.setState({
              isCompareModal: true,
              visitBefore_obj: selected_visitor, // not valid
            })
          } else {
            this.checkEnterNumberAndPreviousNumber();
          }
        } else {
          if (this.state.visitor_id === 0) {
            this.customVisitorsListValidation(0);
          } else {
            this.checkEnterNumberAndPreviousNumber();
          }
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.checkMobileNumber()
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      })
  };

  checkEnterNumberAndPreviousNumber = () => {
    const {t} = this.props;
    let pre_number = this.state.visitor_mobile_background;
    let enter_number = this.state.visitor_mobile.match(/\d/g).join("");

    let modify_number =
      enter_number.startsWith("94") && enter_number.length === 11 ? enter_number.split("94").join('0') : enter_number;

    if (pre_number !== modify_number && !this.state.mobile_confirmation_condi) {
      swal({
        className: "swal-reception-number-check",
        text: t('please_verify_the_mobile_number_of_the_visitor') + ": " + modify_number,
        icon: are_you_sure_icon,
        closeOnClickOutside: false,
        buttons: {
          cancel: t('incorrect'),
          dangerMode: {
            text: t('correct'),
            value: "action",
            className: "okay-btn"
          }
        },
      }).then((value) => {

        switch (value) {
          case "action":
            this.customVisitorsListValidation(0);
            break;
          default:
            break;
        }
      });
    } else {
      this.customVisitorsListValidation(0);
    }
    // else {
    //   swal({
    //     className: "swal-reception-number-check",
    //     text: "Mobile number of this user is not equal to the number you entered. \n\n Entered Number: " + modify_number + "\n Existing Number: " + pre_number + " \n\n Do you wish to replace the existing number?",
    //     icon: are_you_sure_icon,
    //     closeOnClickOutside: false,
    //     buttons: {
    //       cancel: 'NO',
    //       dangerMode: {
    //         text: "YES",
    //         value: "action",
    //         className: "okay-btn"
    //       }
    //     },
    //   }).then((value) => {
    //
    //     switch (value) {
    //       case "action":
    //         this.customVisitorsListValidation(0);
    //         break;
    //       default:
    //         break;
    //     }
    //   });
    // }
  };

  yesHandler = () => {
    let selected_visitor = this.state.visitBefore_obj;
    if (!selected_visitor.visitBefore) {
      this.setState({
        isCompareModal: false,
        visitBefore: false
      })
    } else {
      this.setState({
        isCompareModal: false,
        visitor_id: selected_visitor.visitor.userId,
      });
      this.customVisitorsListValidation(selected_visitor.visitor.userId);
    }
  };

  customVisitorsListValidation = async (id) => {
    let {visitor_id,isUseCard,meeting_pass_no_text,meeting_pass_no} = this.state;
    if (id !== 0 && id !== undefined) {
      visitor_id = id
    }
    let custom_visitors_list = this.state.custom_visitors_list;
    let pass = "";

    if(!isUseCard){
      this.props.all_available_card.map((card, index) => {
        if (card.value === meeting_pass_no) {
          pass = card.text
        }
      });
    }else{
      pass = meeting_pass_no_text;
    }

    let children = []
    if (this.state.children_list.length !== 0 && this.state.visitor_info_type === 'ADULT') {
      this.state.children_list.map(item => {
        children.push({
          title: item.title,
          firstName: item.firstName,
          lastName: item.lastName,
          visitorType: 'CHILD',
          cardId: item.meetingNo
        })
      })
    }

    let personalEmail = "";
    let corporateEmail = "";

    if (this.state.emailType === "Personal") {
      personalEmail = this.state.visitor_email;
      corporateEmail = this.state.visitor_corporate_email;
    } else if (this.state.emailType === "Corporate") {
      personalEmail = this.state.visitor_personal_email;
      corporateEmail = this.state.visitor_email;
    }

    const obj = {
      "identificationValue": this.state.visitor_info_type === 'ADULT' ? this.state.visitor_identify.trim() : null,
      "identificationType": this.state.visitor_info_type === 'ADULT' ? this.state.visitor_identify_type.trim() : null,
      "userId": visitor_id,
      "mobile": this.state.visitor_mobile.trim() ? this.state.visitor_mobile.trim() : null,
      "firstName": this.state.visitor_info_type === 'CHILD' ? this.state.children_list[0].firstName : this.state.visitor_fname === "-" ? "" : this.state.visitor_fname.trim(),
      "lastName": this.state.visitor_info_type === 'CHILD' ? this.state.children_list[0].lastName : this.state.visitor_lname === "-" ? "" : this.state.visitor_lname.trim(),
      "title": this.state.visitor_info_type === 'CHILD' ? this.state.children_list[0].title : this.state.visitor_title.trim(),
      "companyName": this.state.visitor_company.trim(),
      "email": personalEmail.trim() ? personalEmail : null,
      "corporateEmail": corporateEmail.trim() ? corporateEmail : null,
      "emailType": this.state.emailType,
      "cardId": this.state.visitor_info_type === 'CHILD' ? this.state.children_list[0].meetingNo : this.state.meeting_pass_no,
      "pass": pass,
      "photoPath": this.state.screenshot,
      "vehicleNumber": this.state.visitor_vehicle_no.trim() !== '' ? this.state.visitor_vehicle_no.toUpperCase() : '',
      "remark": this.state.visitor_remark,
      "enableOverdueSms": this.state.visitor_info_type === 'CHILD' ? false : this.state.enable_overdue,
      "visitorType": this.state.visitor_info_type,
      "children": this.state.visitor_info_type === 'ADULT' ? children : []
    };

    this.state.visitor_info_type === 'CHILD' ? custom_visitors_list = [obj] : custom_visitors_list.push(obj)
    this.clearVisitor();
    this.setState({
      custom_visitors_list: custom_visitors_list,
      type: "NIC",
      search_visitor:'',
      search_mobile:'',
      valid_search_mobile:false,
      search_mode:false,
      mobile_confirmation_condi:false,
      children_list: this.state.visitor_info_type === 'ADULT' ? [] : this.state.children_list
    });

    if (this.state.visitor_info_type === 'CHILD') this.meetingSheduleHandler();
  };

  sendToBackend = () => {
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    let corporateId = this.props.usr_obj.corporates[0].corporateId;
    let visitingPurpose = this.state.visitor_purpose;

    const obj = {
      meeting: {
        visitingPurpose: visitingPurpose,
        wifi: {
          wifipackageId: this.state.wifi_package,
          expireDate: this.state.selectedDate,
        },
        hostA: this.state.host_1_userid,
        hostB: this.state.host_2_userid,
        floorId: this.state.meeting_floor,
        visitors: this.state.custom_visitors_list
      }
    };

    this.props.spinnerHandler(true);
    axios.put(apiConfig.CORPORATE_MEETING_CREATE(corporateId), obj, { headers: headers })
      .then(response => {
        if (response.data.success) {
          if(this.props.usr_obj.userRoles === "RECEPTION" && this.props.branchId){
            let visitorsList = this.state.custom_visitors_list;
            let idList = [];
            visitorsList.map((obj,index)=>{
              let checkResult = this.props.visitorList.find(visitor => (visitor.error_code === 710 ? visitor.visitor.visitor.userId : visitor.visitor.userId) === obj.userId);
              if(checkResult) idList.push(obj.userId)
            });
            if(idList.length !== 0) this.props.socketDeleteIdListHandler(idList);
          }
          this.enableIsHidden(true);
          this.clearFields();
          this.props.callAllCount(this.props.usr_obj);
          common.warningAlert("Meeting successfully saved", 0);
          this.getAvailableCards(this.props.usr_obj, 1);
          this.getAllCompany();
          this.enableIsHidden(false);
          this.handleAdultChildBtn('ADULT')
        } else {
          this.props.spinnerHandler(false);
          common.warningAlert(response.data.message, 1)
        }
      })

      .catch(async error => {
        if (error.response.status === 417) {
          common.warningAlert("Something went wrong! There are duplicates of some visitor details", 1);
        } else {
          let result = await common.checkErrorResponse(error);
          if (result === 1) {
            this.sendToBackend();
          } else {
            this.props.spinnerHandler(false)
          }
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      })
  };

  scheduleMeetinghandler = () => {
    const {t} = this.props;

    swal({
      title: t('do_you_want_to_proceed'),
      icon: are_you_sure_icon,
      closeOnClickOutside: false,
      buttons: {
        cancel: t('cancel'),
        dangerMode: {
          text: t('yes'),
          value: "action",
          className: "okay-btn"
        }
      },
    })
      .then((value) => {
        switch (value) {
          case "action":
            this.sendToBackend();
            break;
          default:
        }
      });
  };

  enableIsHidden = (type) => {
    this.setState({
      isHidden: type
    })
  };

  meetingSheduleHandler = () => {
    let isHostValidation = this.checkHostValidation();
    if (isHostValidation) {

      let isBuildingValidation = this.checkBuildingValidation();
      if (isBuildingValidation) {
        let isVisitorValidation = this.checkVisitorValidation();
        if (isVisitorValidation) {
          let isWifiValidation = this.checkWifiValidation();
          if (isWifiValidation) {
            this.scheduleMeetinghandler();
          }
        }
      }
    }
  };

  handleQRCode = () => {
    this.setState({
      isScanQR: !this.state.isScanQR
    })
  };
  sendToReceptionist = async (data) => {
    await this.setState({isMobileQR: false, type: DropDownConst.IdentificationsHostWithoutVN(null)[2].value, search_visitor: data, search_mobile: data})
    setTimeout(()=>{
      this.searchVisitorUsingVisitorIdentity();
    },500);
  }
  closeModal = (type, conditon) => {
    this.setState({
      [type]: conditon
    })
  };

  validateCustomerCart = () => {
    let result = false;
    let condition = false;
    let isCard = false;
    let passName = "";
    let list = this.state.custom_visitors_list;
    let identificationValue = this.state.visitor_identify.trim();
    if (list.length !== 0) {
      list.map((custom, index) => {
        if (custom.identificationValue === identificationValue) {
          condition = true;
        }
        if (custom.cardId === this.state.meeting_pass_no) {
          passName = custom.pass;
          isCard = true;
        }
      })
    }
    if (!isCard) {
      if (!condition) {
        result = true;
      } else {
        common.notifyMessage("Already assign this visitor - " + identificationValue);
      }
    } else {
      common.notifyMessage("Already assign this card - " + passName);
    }
    return result;
  };

  addedToVisitorCart = () => {
    let isvalidateCustomerCart = this.validateCustomerCart();
    if (isvalidateCustomerCart) {
      if (this.state.isVisitor) {
        let isCheck = this.checkVisitorEnterVisitorDetails();
        if (isCheck) {
          // this.customVisitorsListValidation(0);
          // this.checkMobileNumber();
          this.addChildrenAction('save');
        }
      } else {
        let isCheck = this.checkVisitorEnterVisitorDetails();
        if (isCheck) {
          // this.checkMobileNumber();
          this.addChildrenAction('save')
        }
      }
    }
  };

  getAvailableCards = (obj, id) => {
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    let cards_list = [];
    axios.get(apiConfig.CORPORATE_ACTIVE_CARD(obj.corporates[0].corporateId), { headers: headers })
      .then(response => {
        this.props.spinnerHandler(false);
        if (response.data.success) {
          let cards = response.data.cards;

          if (cards.length !== 0) {
            cards.map((card, index) => {
              let data = {
                key: card.cardId,
                text: card.passId,
                value: card.cardId,
                image: { avatar: true, src: pass_icon },
              };
              cards_list.push(data)
            })
          } else {
            if (id !== 1) {
              this.noCardsAvailable()
            }
          }
        } else {
          this.noCardsAvailable();
        }
        this.props.receptionAllAvailableCardHandler(cards_list)
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.getAvailableCards(obj, id);
        } else {
          this.props.spinnerHandler(false);
        }
      });
  };

  getAllCompany = () => {
    this.props.spinnerHandler(true);
    this.setState({ company_loader: true });
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    let company_list = [];
    axios.get(apiConfig.COMPANIES, { headers: headers })
      .then(response => {
        if (response.data.success) {
          let content = response.data.content;

          if (content.length !== 0) {
            content.map((company, index) => {
              let data = {
                key: index,
                text: company,
                value: company,
                title: company,
              };
              company_list.push(data)
            })
          }
        }
        this.setState({
          companyList: company_list
        })
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.getAllCompany();
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
        this.setState({ company_loader: false })
      })
  };
  clearVisitor = () => {
    this.setState({
      isTag: false,
      isVisitor: true,
      visitor_identify: '',
      visitor_id: 0,
      visitor_title: '',
      visitor_fname: '',
      visitor_lname: '',
      visitor_mobile: '',
      visitor_mobile_: '',
      visitor_corporate_email: '',
      visitor_personal_email: '',
      visitor_email: '',
      visitor_valid_email: false,
      visitor_valid_mobile: false,
      visitor_company: '',
      isUseCard: false,
      meeting_pass_no: this.state.isUseCard ? '':this.state.meeting_pass_no,
      screenshot: '',
      visitor_vehicle_no:'',
      visitor_remark:'',
      valid_vehicle_no:false,
      visitor_identify_type:'',
      enable_overdue:true,
      emailInputDisabled: false
    })
  };
  clearFields = () => {
    this.setState({isChangeHost: false, search_host: '', host_1: '', host_2: '', host_1_userid: 0, host_2_userid: 0, host_mobile: '', host_extension: '', host_designation: '', host_department: '',
      isWifi: false, wifi_package: 0, wifi_expire_date: '',
      selectedDate: new Date().setDate(new Date().getDate() + 1),
      isTag: false, isVisitor: true, search_visitor: '', visitor_identify: '', visitor_id: 0, visitor_fname: '', visitor_lname: '',
      visitor_mobile: '', visitor_mobile_: '',visitor_corporate_email: '', visitor_personal_email: '', visitor_email: '', visitor_valid_email: false, visitor_valid_mobile: false, visitor_company: '', screenshot: '',
      meeting_building: '', meeting_building_id: 0, building_options: [], meeting_floor: '', meeting_pass_no: '',
      hostList: [], coporate_host: [], custom_visitors_list: [],
      selectedCards: [], visitBefore_obj: null, isScanQR: false, isUseCard: false, type: "NIC",search_mobile:'',
      valid_search_mobile:false,visitor_vehicle_no:'', visitor_remark:'', valid_vehicle_no:false, visitor_identify_type:'',emailInputDisabled: false
    });
  };

  customPlaceholder = (selectedCountryPlaceholder, selectedCountryData) => {
    return selectedCountryData.dialCode + "XXXXXXXXX";
  };

  addChildrenAction = (type) => {
    let isvalid = false
    if (this.state.children_list.length !== 0) {
      this.state.children_list.map((item,i) => {
        if (item.title === '' || item.firstName === '' || item.lastName === '' || (item.meetingNo === '' && this.state.visitor_info_type === 'CHILD')) {
          common.notifyMessage(this.state.visitor_info_type === 'ADULT' ? "Please fill all details of Child "+(i+1) :
            "Please fill all details of the child " );
          isvalid = true
        }
      })
    }
    if (!isvalid) {
      switch (type) {
        case 'add':
          this.state.children_list.push({title:'', firstName:'', lastName:'', meetingNo:''})
          this.forceUpdate()
          break;
        case 'save':
          this.state.visitor_info_type === 'ADULT' ? this.checkMobileNumber() : this.customVisitorsListValidation(0)
          break;
      }
    }
  }

  handleChildrenList = (id,type,value) => {
    switch (type) {
      case "title":
        this.state.children_list[id].title = value
        break;
      case "firstName":
        this.state.children_list[id].firstName = value
        break;
      case "lastName":
        this.state.children_list[id].lastName = value
        break;
      case "meetingNo":
        this.state.children_list[id].meetingNo = value
        break;
    }
    this.forceUpdate()
  }

  handleAdultChildBtn = (type) => {
    this.setState({ visitor_info_type:type })
    type === 'ADULT' ? this.setState({ children_list:[],custom_visitors_list: [] }) :
      this.setState({ children_list:[{title:'', firstName:'', lastName:'', meetingNo: ''}], custom_visitors_list: [] })
  }

  removeChild = (id) => {
    this.state.children_list.splice(id,1);
    this.forceUpdate();
  }

  componentWillUnmount() {
    this.props.imageUploaderHandler([]);
  }

  componentDidMount() {
    $('input').attr('autocomplete', 'off');
    this.props.callAllBuildings(this.props.usr_obj);
    this.props.callAllWifiPackages(this.props.usr_obj);

    this.getAvailableCards(this.props.usr_obj);
    this.getAllCompany();

    let date = this.convertDate(new Date().setDate(new Date().getDate() + 1));
    this.setState({
      wifi_expire_date: date
    });

    $('.visitor-identity').bind('keyup', (event) => {
      if (event.keyCode === 13) {
        this.searchVisitorUsingVisitorIdentity();
      }
    });

    const language = localStorage.getItem('language');
    if (language) {
      i18n.changeLanguage(language);
    }

  }


  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.t !== this.props.t) {
      this.setState({
        searchOptions: DropDownConst.IdentificationsHostWithoutVN(this.props.t),
        visitors_columns: TableHeaders.visitorsColumns(this.props.t)
      });
    }
  }

  emailTypeChangeHandler = (e,{value}) => {
    // console.log(this.state.visitor_email);
    this.setState({emailType: value});
    let corporateEmail = this.state.visitor_corporate_email;
    let personalEmail = this.state.visitor_personal_email;
    if (value === "Corporate") {
      if (corporateEmail !== "") {
        this.setState({visitor_email: corporateEmail})
      } else {
        this.setState({visitor_email: ''})
      }
    } else if (value === "Personal") {
      if (personalEmail !== "") {
        this.setState({visitor_email: personalEmail})
      } else {
        this.setState({visitor_email: ''})
      }
    }
  }



  render() {
    const {t} = this.props;
    let {isMobileQR} = this.state;
    let all_building_list = this.props.all_building_list;
    let floor_options = this.props.all_floor_list;
    let pass_options = this.state.reception_cards;

    const building_options = [];
    // let all_wifi_packages_list = this.props.all_wifi_packages_list;
    // const wifi_pacakge_options = [];

    if (all_building_list.length !== 0) {
      all_building_list.map((element, index) => {
        building_options.push({
          key: index,
          text: element.name,
          value: index,
          image: { avatar: true, src: building_icon },
        })
      })
    }

    /*this.setState({
      searchOptions: DropDownConst.IdentificationsHostWithoutVN(t)
    })*/

    // if (all_wifi_packages_list.length !== 0) {
    //   all_wifi_packages_list.map((element, index) => {
    //     wifi_pacakge_options.push({
    //       key: element.packageId,
    //       text: element.name,
    //       value: element.packageId,
    //       image: { avatar: true, src: wifi_icon },
    //     })
    //   })
    // }

    let visitor_table_rows = [];
    if (this.state.custom_visitors_list.length !== 0) {
      this.state.custom_visitors_list.map((visitor, index) => {
        let childrenString = ''
        if (visitor.children.length !== 0) {
          visitor.children.map(item => [
            childrenString += ", "+item.firstName+" "+item.lastName
          ])
          childrenString = childrenString.substring(1)
        }
        const obj = {
          id: visitor.identificationValue,
          mobile: visitor.mobile,
          fname: visitor.firstName,
          lname: visitor.lastName,
          pass: visitor.pass,
          vehicleNo: visitor.vehicleNumber,
          children: childrenString,
          remove:
            <Tooltip placement="topLeft" title={"Remove " + visitor.firstName}>
              <SementicBtn circular icon='trash alternate' className={"more-remove-card"}
                onClick={() => this.removeVisitor(index, visitor)} />
            </Tooltip>
        };

        visitor_table_rows.push(obj);
      })
    }
    let columns = this.state.visitors_columns;
    let visitor_table_data = { columns: columns, rows: visitor_table_rows };

    let {host_loader,coporate_host,search_host,isChangeHost,host_mobile,host_extension,host_designation,host_department,
      host_1,host_2,isHidden,search_visitor,type,visitor_title,visitor_identify,visitor_fname,visitor_lname,search_mobile,
      visitor_mobile_,companyList_,company_loader,visitor_company,visitor_email,isTag,tagColor,tagDescritpition,
      isUseCard,meeting_pass_no,screenshot,custom_visitors_list,isScanQR,visibleRightDrawer,isVisitor,visitor_remark,
      visitor_vehicle_no,visitor_identify_type,searchOptions,enable_overdue,visitor_info_type,search_mode,emailOptions,emailType,emailInputDisabled} = this.state;
    let {visitors_purpose_options_list} = this.props;

    let childrenDiv = []
    if (this.state.children_list.length !== 0) {
      this.state.children_list.map((item,index) => {
        let temp = index + 1
        childrenDiv.push(<div style={{marginTop:'2rem'}} key={index}>
          {this.state.visitor_info_type === 'ADULT' && <h6 style={{fontWeight:600}}>{"Child "+ temp}</h6>}
          <Row>
            <Col lg="6" md={"12"} sm={"12"} xs={"12"}>
              <LabelDropdown
                required
                // disable={this.state.isVisitor}
                tagText={t('title')}
                placeholder={t('select_title')}
                options={DropDownConst.userTitle}
                value={item.title}
                onChange={(e,{value}) => this.handleChildrenList(index,'title',value)}
              />
            </Col>
            <Col lg="6" md={"12"} sm={"12"} xs={"12"}></Col>
            <Col lg="6" md={"12"} sm={"12"} xs={"12"}>
              <LabelInput
                // disable={this.state.isVisitor}
                required
                tagText={t('first_name')}
                placeholder={t('first_name')}
                value={item.firstName}
                onChange={(e) => this.handleChildrenList(index,'firstName',e.target.value)}
              />
            </Col>
            <Col lg="6" md={"12"} sm={"12"} xs={"12"}>
              <LabelInput
                // disable={this.state.isVisitor}
                required
                lblId={'child-lastName-input'}
                tagText={t('last_name')}
                placeholder={t('last_name')}
                value={item.lastName}
                onChange={(e) => this.handleChildrenList(index,'lastName',e.target.value)}
              />
            </Col>
            <Col lg="12" md={"12"} sm={"12"} xs={"12"}>
              <LabelDropdown
                required={visitor_info_type === 'CHILD'}
                lblId={'child-passNo-input'}
                tagText={t('pass_number')}
                placeholder={t('please_choose_from_above')}
                options={this.props.all_available_card}
                value={item.meetingNo}
                onChange={(e,{value}) => this.handleChildrenList(index,'meetingNo',value)}
              />
            </Col>
            {visitor_info_type === 'ADULT' && <Col>
              <div className='remove-child'><p><a onClick={() => this.removeChild(index)}>{t('remove')}</a></p></div>
            </Col>}
          </Row>
        </div>)
      })
    }

    return (
      <div>
        {
          this.state.isCompareModal ?
            <CompareModal
              type={2}
              warning={"It looks like user account already exists from this mobile number - (" + this.state.visitor_mobile.trim() + ")"}
              enter={this.state}
              db={this.state.visitBefore_obj}
              closeHandler={() => this.setState({ isCompareModal: false })}
              yesHandler={this.yesHandler}
            /> : null
        }
        {
          !this.state.visitBefore ?
            <Validation_MobEmail closeModal={this.closeModal} data={this.state.visitBefore_obj}
              sendData={this.selectVisitor} /> : null
        }

        {/*{
          this.props.usr_obj.userRoles === "RECEPTION" ?
            <h4 className={"route-name-style"}>{this.props.route_name}</h4>
            : <h4 className={"route-none-style"} />
        }*/}
        {
          this.props.usr_obj.userRoles === "RECEPTION" ?
            <h4 className={"route-name-style"}>{t('schedule_meeting')}</h4>
            : <h4 className={"route-none-style"} />
        }
        <Tooltip placement="topLeft" title={t('scan_qr_code')}>
          <SementicBtn onClick={this.handleQRCode} icon className={"qrcode-btn"}>
            <Icon name='qrcode' loading />
          </SementicBtn>
        </Tooltip>

        {isScanQR ? <ScanQR closeModal={this.handleQRCode} /> : null}
        {isMobileQR ? <MobileScanQR sendToReceptionist={(data)=>this.sendToReceptionist(data)} closeModal={()=>this.setState({isMobileQR: false})} />: null}
        {this.props.branchId ? <RightSideDrawer finalizeVisitorDetails={this.finalizeVisitorDetails} closeDrawer={this.closeModal} visibleDrawer={visibleRightDrawer}/> : null}
        {
          this.props.usr_obj.userRoles === "RECEPTION" && this.props.branchId ?
            <div className={visibleRightDrawer ? `enable-right-sidedrawer` : `disable-right-sidedrawer`}
                 onClick={() => this.closeModal("visibleRightDrawer", !visibleRightDrawer)}>
          <Icon name={visibleRightDrawer ? 'angle right':'angle left'} />
            </div> : null
        }

        <Row>
          <Col xs="12" lg={"6"} md={"12"}>
            <Card>
              <CardHeader>
                {/*STAFF INFORMATION & WIFI PACKAGES*/}
                {t('staff_information')}
              </CardHeader>
              <Collapse isOpen={true} id="collapseExample">
                <CardBody>
                  <div id={'staffInformation_sec'}>
                    {/*staff information*/}
                    <LabelDropdown
                      required
                      className={"select-host"}
                      loading={host_loader}
                      btnText={"Get Info"}
                      tagText={t('staff_member')}
                      placeholder={t('enter_name')}
                      options={coporate_host}
                      value={search_host}
                      onSearchChange={this.handleSearchHost}
                      onChange={this.handleSelectHost}
                    />

                    <Checkbox style={{ fontWeight: '600', color: 'rgba(72, 72, 72, 0.87)!important' }}
                      checked={isChangeHost} onChange={this.changeHostOnChange} toggle
                      label={t('assign_other_staff_member')} />

                    <Row style={{ marginTop: '15px' }}>
                      <Col lg="6" md={"12"} sm={"12"} xs={"12"} id={'mobile-input'}>
                        <LabelInput
                          disable
                          lblFontSize={"12px"}
                          tagText={t("mobile_number")}
                          placeholder={t("mobile_number")}
                          value={host_mobile}
                          onChange={this.handleChange('host_mobile')}
                        />
                      </Col>

                      <Col lg="6" md={"12"} sm={"12"} xs={"12"}>
                        <LabelInput
                          disable
                          tagText={t("extension")}
                          placeholder={t("extension")}
                          value={host_extension}
                          onChange={this.handleChange('host_extension')}
                        />
                      </Col>
                    </Row>

                    <LabelInput
                      disable
                      tagText={t("designation")}
                      placeholder={t("designation")}
                      value={host_designation}
                      onChange={this.handleChange('host_designation')}
                    />

                    <LabelInput
                      disable
                      tagText={t("department")}
                      placeholder={t("department")}
                      value={host_department}
                      onChange={this.handleChange('host_department')}
                    />

                    <Row className={"bottom-div"}>
                      <Col xs={"12"} id={'requested-input'}>
                        <LabelInput
                          required
                          disable
                          btnText={"Staff 1"}
                          tagText={t("requested")}
                          placeholder={t('requested_staff')}
                          value={host_1}
                        />
                        {
                          isChangeHost ?
                            <LabelInput
                              required
                              disable
                              btnText={"Staff 2"}
                              tagText={t("assign_to")}
                              placeholder={t("assigned_staff_member_on_behalf_of_requested")}
                              value={host_2}
                            />
                            :
                            null
                        }
                      </Col>
                    </Row>
                    {
                      !isHidden ?
                        <Row className={"bottom-div"}>
                          <Col xs={"12"}>
                            <LabelDropdown
                              required
                              lblId={'building-input'}
                              tagText={t("building")}
                              placeholder={t("select_building")}
                              options={building_options}
                              onChange={this.buildingOnChange}
                            />

                            <LabelDropdown
                              required
                              tagText={t("floor")}
                              placeholder={t('select_floor')}
                              options={floor_options}
                              onChange={this.floorOnChange}
                            />
                            <LabelDropdown
                              className={'visiting-purpose-input'}
                              required
                              lblId={'purpose-input'}
                              lblFontSize={"12px"}
                              lblWidth={ "113px" }
                              tagText={t("visiting_purpose")}
                              placeholder={t("select_visit_type")}
                              options={visitors_purpose_options_list}
                              onChange={this.purposeOnChange}
                            />
                          </Col>
                        </Row>
                        : null
                    }
                    {/*wifi packages*/}
                    {/*<div className={"button-div"}>*/}
                    {/*<Checkbox*/}
                    {/*style={{fontWeight: '600', color: 'rgba(72, 72, 72, 0.87)!important', marginBottom: '7px'}}*/}
                    {/*checked={this.state.isWifi} onChange={this.changeWifiSelector} toggle*/}
                    {/*label='Do you want to enable wifi'/>*/}
                    {/*{*/}
                    {/*this.state.isWifi ?*/}
                    {/*<Row>*/}
                    {/*<Col lg="6" md={"12"} sm={"12"} xs={"12"}>*/}
                    {/*<LabelDropdown*/}
                    {/*required={this.state.isWifi}*/}
                    {/*tagText={"Wifi Package"}*/}
                    {/*placeholder={"Select package"}*/}
                    {/*options={wifi_pacakge_options}*/}
                    {/*onChange={this.wifiOnChange}*/}
                    {/*/>*/}
                    {/*</Col>*/}

                    {/*<Col lg="6" md={"12"} sm={"12"} xs={"12"}>*/}
                    {/*<LabelInput*/}
                    {/*disable*/}
                    {/*required={this.state.isWifi}*/}
                    {/*tagText={"Expire Date"}*/}
                    {/*placeholder={"Please select date"}*/}
                    {/*value={this.state.wifi_expire_date}*/}
                    {/*/>*/}
                    {/*<DatePicker*/}
                    {/*inline*/}
                    {/*selected={this.state.selectedDate}*/}
                    {/*timeInputLabel="Choose Time"*/}
                    {/*onChange={this.handleExpireDate}*/}
                    {/*dateFormat="MM/dd/yyyy h:mm aa"*/}
                    {/*showTimeInput*/}
                    {/*minDate={new Date()}*/}
                    {/*showDisabledMonthNavigation*/}
                    {/*/>*/}
                    {/*</Col>*/}
                    {/*</Row>*/}
                    {/*: null*/}
                    {/*}*/}
                    {/*</div>*/}
                  </div>
                </CardBody>
              </Collapse>
            </Card>
          </Col>

          <Col xs="12" lg={"6"} md={"12"}>
            <Card>
              <CardHeader>
                {t('visitor_information')}
              </CardHeader>
              <Collapse isOpen={true} id="collapseExample">
                <CardBody>
                  <div className="animated fadeIn">

                    <div className="minor-div">
                      <Button onClick={() => this.handleAdultChildBtn('ADULT')} className={visitor_info_type === 'ADULT' ? "active_btn" : "inactive_btn"}>Adult</Button>
                      <Button onClick={() => this.handleAdultChildBtn('CHILD')} className={visitor_info_type === 'CHILD' ? "active_btn" : "inactive_btn"}>Child</Button>
                      <hr/>
                    </div>

                    {
                      visitor_info_type === 'ADULT' ? <>

                    {/*visitor information*/}
                    <Row className={"search-visitor-row "}>
                      <Col lg="9" md={"8"} sm={"8"} xs={"8"}>
                        {
                          this.state.type === 'Mobile' ?
                            <div className={"display-inline"} >
                              <label className="label ui dashboard-mobile-lbl mob-hidden-label">{t('visitor_identity')}</label>
                              <IntlTelInput
                                type={"text"}
                                value={search_mobile}
                                containerClassName="intl-tel-input dashboard-intl"
                                inputClassName="form-control"
                                onPhoneNumberChange={this.searchPhoneNumber}
                                required={true}
                                preferredCountries={['lk']}
                                defaultCountry={"lk"}
                                nationalMode={false}
                                placeholder={t("search_here")}
                                customPlaceholder={this.customPlaceholder}
                              />
                              <Dropdown
                                style={{borderTopLeftRadius:0, borderBottomLeftRadius:0, display:'flex', padding: 14}}
                                button basic floating
                                value={this.state.type}
                                options={searchOptions}
                                className={"end-"}
                                onChange={
                                  (e, {value}) => {
                                    this.setState({
                                      type: value, search_visitor:''
                                    })
                                  }
                                }
                              />
                            </div> :
                            <LabelInputDropdown
                              lblClassname={"mob-hidden-label"}
                              inputClass={"visitor-identity"}
                              tagText={t("visitor_identity")}
                              placeholder={t("search_here")}
                              value={search_visitor}
                              onChange={this.handleChange('search_visitor')}
                              onDropdownChange={
                                (e, { value }) => {
                                  this.setState({
                                    type: value, search_visitor:''
                                  })
                                }
                              }
                              options={searchOptions}
                              dropdownValue={type}
                            />
                        }
                      </Col>
                      <Col lg="3" md={"4"} sm={"4"} xs={"4"} className={"search-visitor-col d-flex"}>
                        <SementicBtn className="px-5 search-visitor-btn"
                          onClick={this.searchVisitorUsingVisitorIdentity}>{t('search')}</SementicBtn>
                        <SementicBtn onClick={()=>this.setState({isMobileQR: true})} icon className={'inline-mob-qr-btn'}>
                          <Icon name='qrcode' />
                        </SementicBtn>
                      </Col>
                    </Row>
                    <br />

                    {
                      search_mode && <>

                        <Row>
                          <Col lg="6" md={"12"} sm={"12"} xs={"12"}>
                            <LabelDropdown
                              required
                              // disable={this.state.isVisitor}
                              tagText={t("title")}
                              placeholder={t("select_title")}
                              options={DropDownConst.userTitle}
                              value={visitor_title}
                              onChange={this.titleOnChange}
                            />
                          </Col>
                          {
                            (type === 'Email' || type === 'Mobile') && <Col lg="6" md={"12"} sm={"12"} xs={"12"}></Col>
                          }
                          <Col lg="6" md={"12"} sm={"12"} xs={"12"} id={'visitor-identity-input-lbl'}>
                            <LabelInput
                              required
                              tagText={t("visitor_identity")}
                              placeholder={t("visitor_identity")}
                              value={visitor_identify}
                              onChange={(this.state.type === 'Email' || this.state.type === 'Mobile') ? this.handleChange('visitor_identify') : null}
                            />
                          </Col>
                          {
                            (type === 'Email' || type === 'Mobile') &&
                            <Col lg="6" md={"12"} sm={"12"} xs={"12"}>
                              <LabelDropdown
                                required
                                // disable={this.state.isVisitor}
                                tagText={t('identity_type')}
                                placeholder={t('select_type')}
                                options={DropDownConst.Identifications(t)}
                                value={visitor_identify_type}
                                onChange={this.identifyTypeOnChange}
                              />
                            </Col>
                          }
                        </Row>

                        <Row>
                          <Col lg="6" md={"12"} sm={"12"} xs={"12"}>
                            <LabelInput
                              // disable={this.state.isVisitor}
                              required
                              tagText={t("first_name")}
                              placeholder={t("first_name")}
                              value={visitor_fname}
                              onChange={this.handleChange('visitor_fname')}
                            />
                          </Col>

                          <Col lg="6" md={"12"} sm={"12"} xs={"12"} id={'last-name-input-lbl'}>
                            <LabelInput
                              // disable={this.state.isVisitor}
                              required
                              tagText={t("last_name")}
                              placeholder={t("last_name")}
                              value={visitor_lname}
                              onChange={this.handleChange('visitor_lname')}
                            />
                          </Col>
                        </Row>

                        <Row>
                          <Col lg="6" md={"12"} sm={"12"} xs={"12"} className={"display-inline"} style={{marginBottom: '12px'}} >
                            <label className="label ui dashboard-mobile-lbl">{t('mobile')}
                              <span className={"required-field-input"}>*</span>
                            </label>
                            <IntlTelInput
                              type={"text"}
                              fieldName={"Mobile Number"}
                              value={visitor_mobile_}
                              containerClassName="intl-tel-input dashboard-intl"
                              inputClassName="form-control"
                              onPhoneNumberChange={type !== 'Mobile' ? this.onPhoneNumberChange : null}
                              required={true}
                              preferredCountries={['lk']}
                              defaultCountry={"lk"}
                              nationalMode={false}
                              customPlaceholder={this.customPlaceholder}
                            />
                          </Col>

                          <Col lg="6" md={"12"} sm={"12"} xs={"12"}>
                            <LabelDropdown
                              clearable
                              tagText={t("company")}
                              placeholder={t("choose_company")}
                              options={companyList_}
                              loading={company_loader}
                              value={visitor_company}
                              onSearchChange={this.handleSearchCompany}
                              onChange={this.companyOnChange}
                            />
                          </Col>
                        </Row>

                        <LabelInput
                          disable={emailInputDisabled}
                          tagText={t("email")}
                          placeholder={t('email')}
                          value={visitor_email}
                          onChange={type !== 'Email' ? this.handleChange('visitor_email') : null}
                        />
                        {
                          /*for tag visitors*/
                          isTag ?
                            <Tag className={"animated fadeInRight"}
                                 color={tagColor}>{tagDescritpition}</Tag>
                            :
                            null
                        }
                        <LabelDropdown
                          className={'pass-number-input-lbl'}
                          required
                          disable={isUseCard}
                          tagText={t("pass_number")}
                          placeholder={t('please_choose_from_above')}
                          options={pass_options}
                          value={meeting_pass_no}
                          onChange={this.passOnChange}
                        />
                        <LabelInput
                          lblId={'lblVehicleNo'}
                          inputClass={'vehicleNo_input'}
                          tagText={t("vehicle_no.")}
                          placeholder={t("vehicle_no.")}
                          value={visitor_vehicle_no}
                          onChange={this.handleChange('visitor_vehicle_no')}
                        />

                        <LabelInput
                          tagText={t("remark")}
                          placeholder={t("remark")}
                          value={visitor_remark}
                          onChange={this.handleChange('visitor_remark')}
                        />

                        <Checkbox style={{ fontWeight: '600', color: 'rgba(72, 72, 72, 0.87)!important' }}
                                  checked={enable_overdue} onChange={this.handleOverdueStatus} toggle
                                  label={t('enable_overdue_message')} />

                        {
                          /* -------------------------------- image upload - start -------------------------------- */
                          visitor_identify.trim() !== "" ?
                            <Collapse isOpen={true} id="collapseExample">
                              <CardBody >
                                <Row>
                                  <Col lg={12} className={"text-align-path col_gap"}>
                                    <Lbl>{t('get_visitor_photo')}</Lbl>
                                    <VisitorPhotoUpload screenshotHandler={this.screenshotHandler} screenshot={screenshot} style={{ marginTop: "40vh" }} />

                                  </Col>
                                </Row>

                              </CardBody>
                            </Collapse>:null
                          /* -------------------------------- image upload - end -------------------------------- */
                        }

                        { childrenDiv }

                        <div className="add-child-div" onClick={() => this.addChildrenAction('add')}>
                          <Icon type="plus" style={{ fontSize: '16px', color: '#08c' }} theme="outlined"/>Add Children
                        </div>

                        {
                          visitor_identify.trim() !== "" ?
                            <Col sm={12} style={{ padding: '0px', textAlign: 'right', marginBottom: '7px' }}>
                              <SementicBtn
                              // className={'addToAttendeeQueue'}
                                icon
                                onClick={this.addedToVisitorCart}>
                                <Icon name='angle down' className="animated infinite bounce delay-2s" />
                                {t('add_to_visitors_queue')}
                              </SementicBtn>
                            </Col>
                            : null
                        }
                      </>
                    }
                    {
                      custom_visitors_list.length !== 0 ?
                        <Col sm={12} style={{ padding: '0px' }}>
                          <MDBDataTable
                            responsive
                            responsiveSm
                            responsiveMd
                            responsiveLg
                            responsiveXl
                            entriesLabel={t('show_entries')}
                            id={"visitors-details-table"}
                            paging={false}
                            searching={false}
                            bordered
                            hover
                            data={visitor_table_data} />
                        </Col>
                        : null
                    }

                      </> : <>
                        { childrenDiv }
                      </>
                    }
                    {/*submit btn*/}
                    {
                      custom_visitors_list.length !== 0 || visitor_info_type === 'CHILD' ?
                        <Row className={"button-div text-align-path"}>
                          <Col xs={"12"}>
                            <Button
                              // id="sbtn"
                              className="submit-btn ui button"
                              onClick={visitor_info_type === 'ADULT' ? this.meetingSheduleHandler : () => this.addChildrenAction('save')}>{t('submit')}</Button>
                          </Col>
                        </Row> : null
                    }

                  </div>
                </CardBody>
              </Collapse>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  custom_visitors_list: state.reception_SheduleMeetingReducer.custom_visitors_list,
  visitors_purpose_options_list: state.reception_SheduleMeetingReducer.visitors_purpose_options_list,

  all_building_list: state.reception_SheduleMeetingReducer.all_building_list,
  all_wifi_packages_list: state.reception_SheduleMeetingReducer.all_wifi_packages_list,
  all_floor_list: state.reception_SheduleMeetingReducer.all_floor_list,
  all_available_card: state.reception_SheduleMeetingReducer.all_available_card,

  building_col: state.reception_SheduleMeetingReducer.building_col,
  visitors_col: state.reception_SheduleMeetingReducer.visitors_col,

  usr_obj: state.userReducer.user,
  image: state.imageReducer.image,
  branchId : state.receptSocketReducer.branchId,
  visitorList : state.receptSocketReducer.visitorList,
});

const mapDispatchToProps = (dispatch) => {
  return {
    callAllBuildings: (data) => dispatch(actionCreator.callAllBuildings(data)), // Get All Buildings Of Corporate
    callAllWifiPackages: (data) => dispatch(actionCreator.callAllWifiPackages(data)), // Get All Wifi Packges Of Corporate
    callAllCount: (data) => dispatch(actionCreator.callAllCount(data)), // Get All counts

    // spinner handler
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
    //user data handler:
    userHandler: (data) => dispatch(actionCreator.userHandler(data)),
    // reception meeting shedule handler
    receptionAddCustomVisitorsHandler: (data) => dispatch(actionCreator.receptionAddCustomVisitorsHandler(data)),

    // all floors
    receptionAllFloorHandler: (data) => dispatch(actionCreator.receptionAllFloorHandler(data)),
    // all building
    receptionAllBuildingHandler: (data) => dispatch(actionCreator.receptionAllBuildingHandler(data)),
    // all available cards
    receptionAllAvailableCardHandler: (data) => dispatch(actionCreator.receptionAllAvailableCardHandler(data)),

    imageUploaderHandler: (image) => dispatch(actionCreator.imageUploaderHandler(image)),
    //  socket
    // delete visitors (socket)
    socketDeleteIdListHandler: (data) => dispatch(actionCreator.socketDeleteIdListHandler(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(App));
